import UP from "./up.svg";
import DOWN from "./down.svg";
import SUN from "./snowflake.svg";
import SNOWFLAKE from "./snowflake.svg";
import LOADER_90RING from "./90-ring.svg";

import { ReactComponent as ArrowUP } from "./arrow-up.svg";
import { ReactComponent as ArrowDOWN } from "./arrow-down.svg";
import { ReactComponent as MoneyCash } from "./money-cash.svg";
import { ReactComponent as SunFilled } from "./sun-filled.svg";
import { ReactComponent as WinterFreeze } from "./winter-freeze.svg";
import { ReactComponent as Change } from "./change.svg";
import { ReactComponent as PasswordError } from "./password-error.svg";
import { ReactComponent as History } from "./history.svg";
import { ReactComponent as Unknown } from "./unknown.svg";
import { ReactComponent as DeactivateOrder } from "./deactivate-orders.svg";
import { ReactComponent as OrderCloseFilled } from "./order-close-filled.svg";
import { ReactComponent as OrderDoneOutline } from "./order-done-outline.svg";
import { ReactComponent as Order } from "./order.svg";
//import { ReactComponent as Loader_90Ring } from "./90-ring.svg";

export {
  UP,
  DOWN,
  SUN,
  SNOWFLAKE,
  LOADER_90RING,
  ArrowUP,
  ArrowDOWN,
  MoneyCash,
  SunFilled,
  WinterFreeze,
  Change,
  PasswordError,
  History,
  Unknown,
  DeactivateOrder,
  OrderCloseFilled,
  OrderDoneOutline,
  Order,
};
